<template>
  <div class="document-composition__container">
    <v-progress-bar md-mode="indeterminate" v-if="isLoading" />

    <template v-if="!isLoading && Object.keys(document).length > 0">
      <document-composition-window :is-disabled="!isEditingExistingFinalizedDocument && !!finalizedDocumentId" @saveDocument="saveDocumentOrGoToPaymentPage" />
    </template>

    <div v-if="document.generalRemarks" class="document-composition__general-remarks">
      <div class="document-composition__general-remarks-button" @click="toggleIsInfoShown">
        <div class="document-composition__general-remarks-button-text">Priporočila o uporabi dokumenta</div>
        <div class="document-composition__general-remarks-button-icon">
          <v-icon v-if="isInfoShown">expand_less</v-icon>
          <v-icon v-else>expand_more</v-icon>
        </div>
      </div>
      <div class="document-composition__general-remarks-content" v-html="generalRemarksMarkdownHtml" ref="infoContent"></div>
    </div>
  </div>
</template>

<script>
import snarkdown from 'snarkdown'
import { mapState, mapActions } from 'vuex'
import Window from './Window'
import VProgressBar from 'design-system/VProgressBar.vue'
import VIcon from 'design-system/VIcon.vue'

export default {
  components: {
    DocumentCompositionWindow: Window,
    VProgressBar,
    VIcon,
  },
  props: {
    id: { type: [String, Number], required: true },
    isEditing: { type: Boolean, default: false },
  },
  data () {
    return {
      isInfoShown: false,
      infoContentHeight: null,
    }
  },
  created () {
    const payload = this.isEditing ? { finalizedDocumentId: this.id } : { documentId: this.id }
    this.initialize(payload)
  },
  beforeDestroy () {
    this.reset()
  },
  watch: {
    document: {
      handler (newDocumentObject, oldDocumentObject) {
        if (Object.keys(oldDocumentObject).length === 0 && Object.keys(newDocumentObject).length > 0) {
          this.$emit('document-loaded')
        }

        this.$nextTick(() => {
          emitDocumentMeta.call(this, newDocumentObject)
          setInfoContentHeight.call(this)
          function emitDocumentMeta (document) {
            if (!document) {
              return
            }
            this.$root.$emit('set-page-meta', { title: document.name })
          }

          function setInfoContentHeight () {
            if (!this.$refs.infoContent) {
              return
            }

            this.infoContentHeight = this.$refs.infoContent.scrollHeight + 100 // some safety margin
          }
        })
      },
    },
  },
  computed: {
    ...mapState(['user']),
    ...mapState('pages/documentComposition', ['document', 'finalizedDocumentId', 'isLoading', 'isEditingExistingFinalizedDocument']),
    generalRemarksMarkdownHtml () {
      if (!this.document.generalRemarks) {
        return ''
      }

      return `${snarkdown(this.document.generalRemarks)}<br/>`
    },
  },
  methods: {
    ...mapActions('pages/documentComposition', ['initialize', 'reset', 'finishDocumentComposition']),
    toggleIsInfoShown () {
      if (!this.isInfoShown && this.$refs.infoContent) {
        this.$refs.infoContent.style.maxHeight = `${this.infoContentHeight}px`
      } else if (this.$refs.infoContent) {
        this.$refs.infoContent.style.maxHeight = 0
      }

      this.isInfoShown = !this.isInfoShown
    },
    saveDocumentOrGoToPaymentPage () {
      if (this.finalizedDocumentId && !this.isEditingExistingFinalizedDocument) {
        this.goToPaymentPage()
      } else {
        this.saveDocument()
      }
    },
    saveDocument () {
      this.finishDocumentComposition()
    },
    goToPaymentPage () {
      this.$router.push({ name: 'finalized_document_payment', params: { id: this.id } })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../common';
@import '../../common';

.document-composition__container {
  position: relative;
  width: 100%;
}

.document-composition__general-remarks {
  margin-top: 24px;
  color: black;
  background-color: white;
  border-radius: 8px;
  user-select: none;
}

.document-composition__general-remarks-button {
  display: flex;
  padding: 32px;
  justify-content: space-between;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;
}

.document-composition__general-remarks-content {
  max-height: 0;
  overflow: hidden;
  padding: 0 32px;
  font-size: 14px;
  transition: .3s cubic-bezier(.25,.8,.25,1);
  transition-property: max-height;
}

::v-deep  .md-checkbox-label {
  height: fit-content;
}
</style>
